import styled from 'styled-components';

interface ContainerProps {
  isDarkMode: boolean;
}

export const MainContainer = styled.div<ContainerProps>`
  background-color: ${(props) =>
    props.isDarkMode ? '#141414' : '#ffffff'};
  color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
  min-height: 100vh;
  padding: 24px 16px;

  @media (max-width: 768px) {
    padding: 16px 12px;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const HeaderContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const HeaderTitle = styled.h1<ContainerProps>`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
`;

export const IconButtonWrapper = styled.button<ContainerProps>`
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: ${(props) => (props.isDarkMode ? '#d9d9d9' : '#666666')};

  &:hover {
    background-color: ${(props) =>
      props.isDarkMode ? '#434343' : '#f0f0f0'};
    color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const MailIcon = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  font-size: 24px;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Section = styled.section<ContainerProps>`
  background-color: ${(props) =>
    props.isDarkMode ? '#262626' : '#ffffff'};
  border-radius: 8px;
  padding: 20px;
  box-shadow: ${(props) =>
    props.isDarkMode
      ? '0 2px 8px rgba(0, 0, 0, 0.45)'
      : '0 2px 8px rgba(0, 0, 0, 0.15)'};

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const EmptyState = styled.div<ContainerProps>`
  text-align: center;
  padding: 48px 24px;
  color: ${(props) => (props.isDarkMode ? '#a6a6a6' : '#999999')};

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: ${(props) => (props.isDarkMode ? '#ffffff' : '#000000')};
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
`;
